import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { PutAprovacaoServicoExecutadoDto } from '@data/servico-executado/dto';

@Injectable()
export class ServicoExecutadoRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.ORDEM_SERVICO);
  }

  putAprovacao(data: PutAprovacaoServicoExecutadoDto) {
    return this.customClient.put(`${this.basePath}/aprovacao`, data).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }
}
